import kamala from '../../kamala'
import MessageBox, { extend } from './MessageBoxManager'
import _ from 'lodash'

MessageBox.install = function (Vue, options) {
  _.assign(extend, options)

  kamala(Vue)

  // Vue.component(MessageBox.name, MessageBox)
  Vue.prototype.$msgBox = MessageBox.msgBox
  Vue.prototype.$alert = MessageBox.alert
  Vue.prototype.$confirm = MessageBox.confirm
}

export default MessageBox
